import React from "react";
import { Tabs } from "antd";
import ManageVendor from "./ManageVendor";
import ManageExpesecat from "./ManageExpesecat";

import { Empty } from "antd";
import { canViewModule } from "../../../utils/permissionUtils";

const MODULE_KEY = "manage_expense";

const ManageExpense = () => {

    const tabItems = [
        {
            key: "vendor",
            label: "Manage Vendor",
            children: <ManageVendor />,
        },
        {
            key: "category",
            label: "Manage Expense Category",
            children: <ManageExpesecat />,
        },
    ];

      if (!canViewModule(MODULE_KEY)) {
        return <Empty description="No permission to view this page" />;
    }

    return (
        <div style={{ padding: 20 }}>
            <Tabs
                size="large"
                items={tabItems}
                defaultActiveKey="vendor"
                tabPosition="left"
                style={{ height: 400 }}
            />
        </div>
    );
};

export default ManageExpense;